import sanitize from 'sanitize-html';
import { useTranslations } from '@hooks/useTranslations';

export function useGetNotEscapedTranslationMarkup() {
    const { t } = useTranslations();

    const getNotEscapedTranslationMarkup = (translationKey: string, withExtraLines?: boolean) => {
        return {
            __html: `${sanitize(t(translationKey, { interpolation: { escapeValue: false } }))}${
                withExtraLines ? '<br><br>' : ''
            }`,
        };
    };

    return { getNotEscapedTranslationMarkup };
}
